module.exports = __webpack_public_path__ + "img/查看国内核心期刊详情.a6366274.png";